import { render, staticRenderFns } from "./SliderBehavior.vue?vue&type=template&id=0c380e68&"
import script from "./SliderBehavior.vue?vue&type=script&lang=js&"
export * from "./SliderBehavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports